// extracted by mini-css-extract-plugin
export default {"image":"styles_image__DAEu3","noPhoto":"styles_noPhoto__j0JE9","imagesNum":"styles_imagesNum__TttQE"};